import React from 'react'
import { Link } from "react-router-dom";


const Gallery = () => {
    return (
        <>

            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>Our Gallery</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item">Our Gallery</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a href="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/unnamed.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/unnamed_1.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/unnamed_2.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <div className="dz-team style-1 box-hover">
                                <div className="dz-media">
                                    <img src="./assets/img/unnamed_3.webp" alt="/" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Gallery